// Loginscherm: één knop naar de connector (Microsoft-login). Rustig, met het monogram.

export function Login(props: { message?: string }) {
  return (
    <main className="min-h-full flex items-center justify-center p-6">
      <div className="w-full max-w-sm bg-surface rounded-lg shadow-card border border-line p-8 text-center">
        <img src="/brand/jerome-mark-light.svg" alt="" width={56} height={56} className="mx-auto mb-4" />
        <h1 className="font-display text-3xl mb-1">Jerome</h1>
        <p className="text-muted mb-6">Je persoonlijke mailassistent.</p>
        {props.message ? <p className="text-red text-sm mb-4">{props.message}</p> : null}
        <a
          href="/auth/login"
          className="inline-flex w-full items-center justify-center rounded-md bg-ink text-white px-4 py-2.5 font-medium hover:bg-bar-2 focus-visible:outline-accent"
        >
          Inloggen met Microsoft
        </a>
        <p className="text-muted text-xs mt-4">Alleen het account van Jeroen de Vries wordt toegelaten.</p>
      </div>
    </main>
  );
}
